import { Container, Flex } from '@grupoboticario/flora-react';
import { useLocation } from 'react-router-dom';

import { PageInfo, ResponsiveFloraTypography } from 'components';
import config from 'config';
import { MLDCatalog } from 'domains/catalog';

import Styles from '../../Catalogs.styles';
import { CardCatalog, CardCatalogSkeleton } from '../CardCatalog';

const CycleCatalog = ({
  pageTitle,
  description,
  catalogs,
  isLoading,
  isNextCycle,
}: {
  pageTitle?: string;
  description?: string;
  catalogs?: MLDCatalog[] | null;
  isLoading?: boolean;
  isSuccess?: boolean;
  isNextCycle?: boolean;
}) => {
  const { pathname } = useLocation();

  return (
    <Flex direction='column' gap='$4'>
      <Container size='large'>
        <PageInfo
          breadcrumbs={[
            {
              text: config.app.catalogName,
              url: '/catalogos-dos-ciclos',
            },
            {
              text: pageTitle || '',
              url: pathname,
            },
          ]}
        />
        <Flex direction='column' gap='$2'>
          <ResponsiveFloraTypography fontSize='title' fontWeight='bold' as='h1'>
            {pageTitle}
          </ResponsiveFloraTypography>

          <ResponsiveFloraTypography fontWeight='medium'>{description}</ResponsiveFloraTypography>
        </Flex>
      </Container>
      <Styles.Wrapper>
        <Container size='large'>
          <Styles.SectionWrapper>
            <Styles.Catalogs>
              {Boolean(isLoading) && (
                <>
                  {[...Array(4)].map((_, index) => (
                    <CardCatalogSkeleton key={index} />
                  ))}
                </>
              )}
              {Boolean(catalogs?.length && !isLoading) &&
                catalogs?.map((catalog) => (
                  <CardCatalog key={catalog.brand} {...catalog} isNextCycle={isNextCycle} />
                ))}
            </Styles.Catalogs>
          </Styles.SectionWrapper>
        </Container>
      </Styles.Wrapper>
    </Flex>
  );
};
export default CycleCatalog;
